import { z } from "zod";

const promptSchema = z.string().trim().min(1).max(500);

export const enrollmentQuestionInputSchema = z.object({
  id: z.string().min(1).max(64).optional(),
  prompt: promptSchema,
});

export const enrollmentQuestionnairePutSchema = z.object({
  questions: z.array(enrollmentQuestionInputSchema).max(30),
});

export const questionnaireAnswersSchema = z.record(
  z.string().min(1).max(64),
  z.string().trim().min(1).max(5000)
);
